/********************************************************
 *                                                      *
 * ---------------------- UTILS ----------------------- *
 *                                                      *
 ********************************************************/

import { DATA_NAMES } from './constants';
import { LooseObject } from './types';

// --- Check Analytics.js //
export function checkAnalytics(): boolean {
    return typeof window.analytics === 'object';
}

// --- Get DOM Elements //
export function getElements(): LooseObject {
    return {
        videoElements: document.querySelectorAll(DATA_NAMES.VIDEO),
    };
}

// --- Get Attribute Values //
export function getDataAttributeValue(element: HTMLElement, attribute: string): string {
    const value = element.getAttribute(attribute);
    if (!value) {
        return '';
    }
    return value;
}

// --- Get StandardProperties (global custom properties) //
export function getStandardProperties(): LooseObject {
    return {
        // standard properties for events
    };
}
